import React, { useEffect, useState, useCallback, useRef } from 'react';
import api from '../services/api';
import Modal from './Modal';
import Spinner from './Spinner';
import { toast } from './Toast';
import { exportCSV, printTable } from './ExportButton';

const CAMPURI_OBLIGATORII_ADD = [
  ['nrInmatriculare','Nr. Înmatriculare'], ['nrInventar','Nr. Inventar'],
  ['marca','Marcă'], ['model','Model'], ['tip','Tip'], ['combustibil','Combustibil'],
  ['capacitateRezervor','Capacitate rezervor'], ['serieSasiu','Serie Șasiu'],
  ['valAchizitie','Valoare achiziție'], ['dataAchizitiei','Data achiziției'],
  ['dataPrimeiInmatr','Data primei înmatriculări'], ['kmInitiali','KM inițiali'],
  ['dataProximaRevizie','Data următoarei revizii'], ['kmLimitaRevizie','KM limită pentru revizie'],
];

// Curata datele brute de vehicul (20+ campuri din baza de date) inainte de export/print,
// pastrand DOAR coloanele vizibile in tabelul de pe ecran - altfel raportul iese cu
// coloane tehnice inutile (activ, areCheltuieli, operare, anvelope, dimensiuni etc.)
// si nu mai incape pe pagina.
function pentruExportVehicule(lista) {
  return lista.map(r => ({
    'Nr. Înmatriculare': r.nrInmatriculare,
    'Nr. Inventar': r.nrInventar,
    'Marca': r.marca,
    'Model': r.model,
    'Tip': r.tip,
    'Combustibil': r.combustibil,
    'Serie Șasiu': r.serieSasiu,
    'Data primei înmatriculări': r.dataPrimeiInmatr,
    'KM inițiali': r.kmInitiali,
    'Stare': r.activ === 0 || r.activ === false || r.activ === '0' ? 'Inactiv' : 'Activ',
  }));
}

function printDetaliiVehicul(nr, marca, model, details) {
  if (!details) return;
  const card = (label, value) => `<div style="background:white;border:1px solid #dde4ec;border-radius:6px;padding:8px 14px;flex:1;min-width:140px">
    <div style="font-size:11px;color:#888;margin-bottom:3px">${label}</div>
    <div style="font-weight:bold;font-size:13px;color:#1a3a5c">${value ?? '—'}</div></div>`;

  const html = `
    <html><head><title>Detalii ${nr}</title>
    <style>body{font-family:Arial,sans-serif;font-size:12px;padding:16px} h2{color:#1a3a5c;margin-bottom:4px}
    .sect{font-size:11px;font-weight:bold;color:#666;text-transform:uppercase;margin:14px 0 6px}
    .row{display:flex;gap:10px;flex-wrap:wrap} @media print{button{display:none}}</style>
    </head><body>
    <h2>Detalii — ${nr} — ${marca||''} — ${model||''}</h2>
    <p style="color:#888;margin-bottom:8px;font-size:11px">Generat: ${new Date().toLocaleString('ro-RO')}</p>

    <div class="sect">Expirări documente</div>
    <div class="row">
      ${card('Expirare ITP', details.expirareItp)}
      ${card('Expirare RCA', details.expirareRca)}
      ${card('Expirare Vigneta', details.expirareVigneta)}
    </div>

    <div class="sect">Statistici</div>
    <div class="row">
      ${card('Consum mediu', details.consumMediu?`${details.consumMediu} l/100km`:null)}
      ${card('Ultimii KM înregistrați', details.ultimiiKm?`${details.ultimiiKm} km`:null)}
      ${card('Ultima revizie', details.ultimaRevizie)}
    </div>

    <div class="sect">Cheltuieli</div>
    <div class="row">
      ${card('🔧 Piese', parseFloat(details.chelPiese||0)>0?`${parseFloat(details.chelPiese).toFixed(2)} RON`:'—')}
      ${card('🏭 Service', parseFloat(details.chelService||0)>0?`${parseFloat(details.chelService).toFixed(2)} RON`:'—')}
      ${card('🔵 Vulcanizare', parseFloat(details.chelVulcanizare||0)>0?`${parseFloat(details.chelVulcanizare).toFixed(2)} RON`:'—')}
      ${card('🛡️ Asigurări', parseFloat(details.chelAsigurari||0)>0?`${parseFloat(details.chelAsigurari).toFixed(2)} RON`:'—')}
      ${card('📋 Autorizări', parseFloat(details.chelAutorizari||0)>0?`${parseFloat(details.chelAutorizari).toFixed(2)} RON`:'—')}
      ${card('⛽ Carburant', parseFloat(details.chelCarburant||0)>0?`${parseFloat(details.chelCarburant).toFixed(2)} RON`:'—')}
      ${card('🔩 Revizii', parseFloat(details.chelRevizii||0)>0?`${parseFloat(details.chelRevizii).toFixed(2)} RON`:'—')}
    </div>
    <div style="background:#1a3a5c;color:white;border-radius:6px;padding:8px 14px;display:inline-block;font-weight:bold;margin-top:10px">
      TOTAL: ${parseFloat(details.chelTotal||0).toFixed(2)} RON
    </div>

    <script>window.onload=()=>window.print()</script>
    </body></html>`;

  const w = window.open('', '_blank');
  w.document.write(html);
  w.document.close();
}

const EMPTY = {
  nrInmatriculare:'', marca:'', model:'', tip:'', combustibil:'',
  capacitateRezervor:'', anvelopeMarca:'', anvelopeTip:'',
  anvelopeMarcaIarna:'', anvelopeTipIarna:'', serieSasiu:'',
  valAchizitie:'', dataAchizitiei:'', dataPrimeiInmatr:'',
  nrAxe:'', kmInitiali:'', lungime:'', latime:'', inaltime:'',
  gabarit:'', nrInventar:'', dataProximaRevizie:'', kmLimitaRevizie:''
};

function FilterInput({ value, onChange }) {
  return <input value={value} onChange={e => onChange(e.target.value)} placeholder="Filtrează..."
    style={{width:'100%',padding:'3px 6px',fontSize:11,border:'1px solid #ccc',borderRadius:3}} />;
}

function expColor(zile) {
  if (zile === null || zile === undefined) return '#f7f9fc';
  if (zile < 0) return '#fde8e8';
  if (zile <= 30) return '#fff3cd';
  return '#e8f8ee';
}

function ExpCard({ label, value, zile }) {
  return (
    <div style={{background:expColor(zile),border:'1px solid #dde4ec',borderRadius:6,padding:'8px 14px',flex:1,minWidth:160}}>
      <div style={{fontSize:11,color:'#888',marginBottom:3}}>{label}</div>
      <div style={{fontWeight:'bold',fontSize:14,color:'#1a3a5c'}}>{value||'—'}</div>
      {zile !== null && zile !== undefined && (
        <div style={{fontSize:11,marginTop:2,color:zile<0?'#c0392b':zile<=30?'#856404':'#1a7a3a'}}>
          {zile<0?`Expirat de ${Math.abs(zile)} zile`:`${zile} zile rămase`}
        </div>
      )}
    </div>
  );
}

function StatCard({ label, value }) {
  return (
    <div style={{background:'white',border:'1px solid #dde4ec',borderRadius:6,padding:'8px 14px',flex:1,minWidth:160}}>
      <div style={{fontSize:11,color:'#888',marginBottom:3}}>{label}</div>
      <div style={{fontWeight:'bold',fontSize:13,color:'#1a3a5c'}}>{value||'—'}</div>
    </div>
  );
}

function ChelCard({ label, value }) {
  const v = parseFloat(value||0);
  return (
    <div style={{background:'white',border:'1px solid #dde4ec',borderRadius:6,padding:'8px 14px',flex:1,minWidth:140}}>
      <div style={{fontSize:11,color:'#888',marginBottom:3}}>{label}</div>
      <div style={{fontWeight:'bold',fontSize:13,color:v>0?'#c0392b':'#888'}}>{v>0?`${v.toFixed(2)} RON`:'—'}</div>
    </div>
  );
}

export default function AutoTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  // Randuri expandate (mai multe simultan) + detaliile + filtrul de perioada per vehicul
  const [expanded, setExpanded] = useState({});     // { [nrInmatriculare]: true/false }
  const [detailsMap, setDetailsMap] = useState({});  // { [nrInmatriculare]: detalii sau null in curs de incarcare }
  const [dateFiltersMap, setDateFiltersMap] = useState({}); // { [nrInmatriculare]: {dataStart, dataEnd} }
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [filters, setFilters] = useState({});
  const [sort, setSort] = useState({ col: 'nrInmatriculare', dir: 'asc' });
  const username = localStorage.getItem('username') || '';
  const isDriver = (localStorage.getItem('rol') || '') === 'conducator_auto';

  const load = () => {
    setLoading(true);
    api.get('/api/auto')
      .then(r => setRows(r.data))
      .catch(e => toast('Eroare la încărcarea vehiculelor: ' + (e.response?.data?.error || e.message), 'error'))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const setFilter = (col, val) => setFilters(prev => ({ ...prev, [col]: val }));

  const esteActiv = (r) => r.activ !== 0 && r.activ !== false && r.activ !== '0';

  const filtered = rows.filter(r =>
    Object.entries(filters).every(([col, val]) => !val || String(r[col]||'').toLowerCase().includes(val.toLowerCase()))
  );

  const sorted = [...filtered].sort((a, b) => {
    // Vehiculele dezactivate raman mereu la finalul listei, indiferent de coloana pe care se sorteaza
    const aActiv = esteActiv(a), bActiv = esteActiv(b);
    if (aActiv !== bActiv) return aActiv ? -1 : 1;
    const av = String(a[sort.col]||'').toLowerCase();
    const bv = String(b[sort.col]||'').toLowerCase();
    return sort.dir === 'asc' ? av.localeCompare(bv) : bv.localeCompare(av);
  });

  const toggleSort = (col) => setSort(prev => ({ col, dir: prev.col === col && prev.dir === 'asc' ? 'desc' : 'asc' }));
  const sortIcon = (col) => sort.col === col ? (sort.dir === 'asc' ? ' ▲' : ' ▼') : ' ⇅';

  const loadDetails = useCallback((nr, ds, de) => {
    let url = `/api/auto/${nr}/details`;
    if (ds && de) url += `?dataStart=${ds}&dataEnd=${de}`;
    api.get(url)
      .then(r => setDetailsMap(prev => ({ ...prev, [nr]: r.data })))
      .catch(() => setDetailsMap(prev => ({ ...prev, [nr]: null })));
  }, []);

  // Deschide/închide detaliile chiar sub vehiculul pe care s-a dat click. Se pot ține
  // deschise oricâte vehicule simultan (nu doar unul singur).
  const toggleRow = (row) => {
    const nr = row.nrInmatriculare;
    setExpanded(prev => {
      const willOpen = !prev[nr];
      if (willOpen) {
        const filt = dateFiltersMap[nr] || {};
        loadDetails(nr, filt.dataStart, filt.dataEnd);
      }
      return { ...prev, [nr]: willOpen };
    });
  };

  const toateExtinse = sorted.length > 0 && sorted.every(r => expanded[r.nrInmatriculare]);
  const extindeToate = () => {
    if (toateExtinse) { setExpanded({}); return; }
    const next = {};
    sorted.forEach(r => {
      const nr = r.nrInmatriculare;
      next[nr] = true;
      if (!detailsMap[nr]) {
        const filt = dateFiltersMap[nr] || {};
        loadDetails(nr, filt.dataStart, filt.dataEnd);
      }
    });
    setExpanded(next);
  };

  const applyDateFilter = (nr) => {
    const filt = dateFiltersMap[nr] || {};
    loadDetails(nr, filt.dataStart, filt.dataEnd);
  };
  const clearDateFilter = (nr) => {
    setDateFiltersMap(prev => ({ ...prev, [nr]: { dataStart:'', dataEnd:'' } }));
    loadDetails(nr, '', '');
  };
  const setDateFilterField = (nr, field, val) => {
    setDateFiltersMap(prev => ({ ...prev, [nr]: { ...(prev[nr]||{}), [field]: val } }));
  };

  const [importModal, setImportModal] = useState(false);
  const [importErori, setImportErori] = useState(null);
  const [importErrorMsg, setImportErrorMsg] = useState(null);
  const [importSuccessMsg, setImportSuccessMsg] = useState(null);
  const [importing, setImporting] = useState(false);
  const [tooltipVizibil, setTooltipVizibil] = useState(null); // 'descarca' | 'incarca' | null
  const fileInputRef = useRef(null);

  const deschideImport = () => {
    setImportErori(null); setImportErrorMsg(null); setImportSuccessMsg(null);
    setImportModal(true);
  };

  const descarcaMacheta = async () => {
    try {
      const r = await api.get('/api/auto/import/macheta', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement('a');
      a.href = url; a.download = 'macheta_import_vehicule.xlsx';
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast('Nu s-a putut descărca macheta', 'error');
    }
  };

  const incarcaMacheta = () => fileInputRef.current?.click();

  const onFisierSelectat = async (e) => {
    const fisier = e.target.files?.[0];
    e.target.value = ''; // permite reselectarea aceluiași fișier
    if (!fisier) return;

    setImporting(true);
    setImportErori(null); setImportErrorMsg(null); setImportSuccessMsg(null);
    try {
      const fd = new FormData();
      fd.append('fisier', fisier);
      fd.append('operare', username);
      const r = await api.post('/api/auto/import', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setImportSuccessMsg(`${r.data.inserate} vehicul(e) importat(e) cu succes!`);
      load();
    } catch (e) {
      if (e.response?.data?.erori) {
        setImportErrorMsg(e.response.data.error);
        setImportErori(e.response.data.erori);
      } else {
        setImportErrorMsg(e.response?.data?.error || e.message);
      }
    } finally {
      setImporting(false);
    }
  };

  const openAdd = async () => {
    // La fel ca la utilizatori: verificăm limita ÎNAINTE de a deschide formularul,
    // nu abia după ce utilizatorul a completat tot și a apăsat "Salvează".
    try {
      const r = await api.get('/api/admin/limite');
      const { nrMasini, limitaMasini } = r.data;
      if (nrMasini >= limitaMasini) {
        const vreiSaContinui = window.confirm(
          `Ai atins limita de ${limitaMasini} vehicul(e) înregistrate (${nrMasini}/${limitaMasini}).\n\n` +
          `Nu poți adăuga un vehicul nou fără să ceri creșterea limitei.\n\n` +
          `Vrei să treci la pagina „Limită cont" pentru a trimite o cerere de creștere?`
        );
        if (vreiSaContinui) {
          sessionStorage.setItem('adminInitialTab', 'limite');
          window.dispatchEvent(new CustomEvent('navigateAdmin'));
        }
        return;
      }
    } catch (e) {
      // Daca verificarea limitei nu a mers, nu blocam - backend-ul o va respinge
      // oricum la trimitere daca limita e atinsa.
    }
    setForm(EMPTY); setModal({ mode: 'add' });
  };
  const openEdit = (row, e) => { e.stopPropagation(); setForm({ ...EMPTY, ...row }); setModal({ mode: 'edit', nr: row.nrInmatriculare }); };

  const save = async () => {
    if (modal.mode === 'add') {
      const lipsa = CAMPURI_OBLIGATORII_ADD.filter(([key]) => !String(form[key]||'').trim());
      if (lipsa.length > 0) {
        toast('Completează câmpurile obligatorii: ' + lipsa.map(([,label])=>label).join(', ') + '.', 'error');
        return;
      }
    }
    try {
      const payload = { ...form, operare: username };
      if (modal.mode === 'add') await api.post('/api/auto', payload);
      else await api.put(`/api/auto/${modal.nr}`, payload);
      setModal(null); load();
      toast(modal.mode === 'add' ? 'Autovehicul adăugat!' : 'Autovehicul actualizat!');
    } catch (e) { toast('Eroare: ' + (e.response?.data?.error || e.message), 'error'); }
  };

  const del = async (row, e) => {
    e.stopPropagation();
    const nr = row.nrInmatriculare;
    if (row.areCheltuieli) {
      const dezactiveaza = window.confirm(
        `Vehiculul ${nr} are cheltuieli înregistrate (piese, revizii, asigurări, autorizări, carburant etc.) și nu poate fi șters.` +
        '\n\nVrei să îl dezactivezi în schimb? Va rămâne vizibil în listă (la final), dar nu va mai putea fi ales la cheltuieli noi.'
      );
      if (dezactiveaza) {
        try {
          await api.put(`/api/auto/${nr}/activ`, { activ: false });
          load(); toast('Vehicul dezactivat!');
        } catch (err2) { toast('Eroare la dezactivare: ' + (err2.response?.data?.error || err2.message), 'error'); }
      }
      return;
    }
    if (!window.confirm(`Ești sigur că vrei să ștergi definitiv autovehiculul ${nr}?\n\nAceastă acțiune este ireversibilă.`)) return;
    if (!window.confirm(`Confirmă din nou: chiar ștergi definitiv ${nr}?`)) return;
    try {
      await api.delete(`/api/auto/${nr}`);
      setExpanded(prev => { const n = {...prev}; delete n[nr]; return n; });
      setDetailsMap(prev => { const n = {...prev}; delete n[nr]; return n; });
      load(); toast('Autovehicul șters!');
    } catch (err) {
      if (err.response?.data?.areCheltuieli) {
        const dezactiveaza = window.confirm(
          (err.response.data.error || 'Vehiculul are cheltuieli înregistrate și nu poate fi șters.') +
          '\n\nVrei să îl dezactivezi în schimb? Va rămâne vizibil în listă (la final), dar nu va mai putea fi ales la cheltuieli noi.'
        );
        if (dezactiveaza) {
          try {
            await api.put(`/api/auto/${nr}/activ`, { activ: false });
            load(); toast('Vehicul dezactivat!');
          } catch (err2) { toast('Eroare la dezactivare: ' + (err2.response?.data?.error || err2.message), 'error'); }
        }
      } else {
        toast('Eroare la ștergere: ' + (err.response?.data?.error || err.message), 'error');
      }
    }
  };

  const toggleActiv = async (row, e) => {
    e.stopPropagation();
    const activeaza = !esteActiv(row);
    const mesaj = activeaza
      ? `Reactivezi vehiculul ${row.nrInmatriculare}? Va reapărea în listele de repartizare a cheltuielilor.`
      : `Dezactivezi vehiculul ${row.nrInmatriculare}? Va fi mutat la finalul listei și nu va mai putea fi ales la cheltuieli noi.`;
    if (!window.confirm(mesaj)) return;
    try {
      await api.put(`/api/auto/${row.nrInmatriculare}/activ`, { activ: activeaza });
      load();
      toast(activeaza ? 'Vehicul reactivat!' : 'Vehicul dezactivat!');
    } catch (err) { toast('Eroare: ' + (err.response?.data?.error || err.message), 'error'); }
  };

  const OBLIGATORII_SET = new Set(CAMPURI_OBLIGATORII_ADD.map(([key]) => key));
  const f = (field, label, type = 'text', opts = null) => (
    <div className="form-group">
      <label>{label}{OBLIGATORII_SET.has(field) && <span style={{color:'#e74c3c'}}> *</span>}</label>
      {opts
        ? <select value={form[field]||''} onChange={e => setForm({...form,[field]:e.target.value})}>
            <option value="">--</option>{opts.map(o => <option key={o}>{o}</option>)}
          </select>
        : <input type={type} value={form[field]||''} onChange={e => setForm({...form,[field]:e.target.value})} />
      }
    </div>
  );

  const SH = ({ col, children }) => (
    <th onClick={() => toggleSort(col)} style={{cursor:'pointer',userSelect:'none',whiteSpace:'nowrap'}}>
      {children}{sortIcon(col)}
    </th>
  );

  return (
    <div>
      <div className="filter-bar">
        {!isDriver && <button className="btn btn-success" onClick={openAdd}>+ Adaugă autovehicul</button>}
        <div style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:12}}>
          <button className="btn btn-sm" style={{background:'#217346',color:'white'}} onClick={()=>exportCSV(pentruExportVehicule(sorted),'vehicule')}>📊 CSV</button>
          <button className="btn btn-sm" style={{background:'#555',color:'white'}} onClick={()=>printTable('Vehicule',pentruExportVehicule(sorted))}>🖨️ Listare</button>
          {sorted.length > 0 && (
            <button className="btn btn-sm" style={{background:'#2d6ca2',color:'white'}} onClick={extindeToate}>
              {toateExtinse ? '▲ Restrânge tot' : '▼ Extinde tot'}
            </button>
          )}
          <span style={{fontSize:11,color:'#888'}}>{sorted.length} înregistrări</span>
          {Object.values(filters).some(v=>v) && (
            <span style={{fontSize:11,color:'#e74c3c',fontWeight:'bold'}}>Filtre active</span>
          )}
        </div>
      </div>

      {loading ? <Spinner /> : (
        <div style={{overflowX:'auto'}}>
          <table>
            <thead>
              <tr>
                <SH col="nrInmatriculare">Nr. Înmatriculare</SH>
                <SH col="nrInventar">Nr. Inventar</SH>
                <SH col="marca">Marcă</SH>
                <SH col="model">Model</SH>
                <SH col="tip">Tip</SH>
                <SH col="combustibil">Combustibil</SH>
                <SH col="serieSasiu">Serie Șasiu</SH>
                <SH col="dataPrimeiInmatr">Prima înmatr.</SH>
                <SH col="kmInitiali">KM inițiali</SH>
                <th style={{width:120}}>Acțiuni</th>
              </tr>
              <tr style={{background:'#f0f4fa'}}>
                <th><FilterInput value={filters.nrInmatriculare||''} onChange={v=>setFilter('nrInmatriculare',v)}/></th>
                <th><FilterInput value={filters.nrInventar||''} onChange={v=>setFilter('nrInventar',v)}/></th>
                <th><FilterInput value={filters.marca||''} onChange={v=>setFilter('marca',v)}/></th>
                <th><FilterInput value={filters.model||''} onChange={v=>setFilter('model',v)}/></th>
                <th><FilterInput value={filters.tip||''} onChange={v=>setFilter('tip',v)}/></th>
                <th><FilterInput value={filters.combustibil||''} onChange={v=>setFilter('combustibil',v)}/></th>
                <th><FilterInput value={filters.serieSasiu||''} onChange={v=>setFilter('serieSasiu',v)}/></th>
                <th></th><th></th><th></th>
              </tr>
            </thead>
            <tbody>
              {sorted.map(r => {
                const nr = r.nrInmatriculare;
                const isExpanded = !!expanded[nr];
                const details = detailsMap[nr];
                const df = dateFiltersMap[nr] || {};
                return (
                  <React.Fragment key={nr}>
                    <tr onClick={() => toggleRow(r)}
                      style={{cursor:'pointer',background:isExpanded?'#e8f0fe':(esteActiv(r)?'':'#f5f5f5'),opacity:esteActiv(r)?1:0.6}}>
                      <td><b>{isExpanded?'▼ ':'▶ '}{r.nrInmatriculare}</b>{!esteActiv(r) &&
                        <span className="badge" style={{background:'#eee',color:'#888',marginLeft:6}}>Inactiv</span>}</td>
                      <td>{r.nrInventar}</td>
                      <td>{r.marca}</td><td>{r.model}</td><td>{r.tip}</td>
                      <td>{r.combustibil}</td><td>{r.serieSasiu}</td>
                      <td>{r.dataPrimeiInmatr}</td><td>{r.kmInitiali}</td>
                      <td onClick={e=>e.stopPropagation()}>
                        {!isDriver && (
                          <>
                            <button className="btn btn-warning btn-sm" onClick={e=>openEdit(r,e)}>✏️</button>{' '}
                            <button className="btn btn-sm" style={{background:esteActiv(r)?'#888':'#27ae60',color:'white'}}
                              onClick={e=>toggleActiv(r,e)} title={esteActiv(r)?'Dezactivează':'Reactivează'}>
                              {esteActiv(r)?'🚫':'✅'}
                            </button>{' '}
                            <button className="btn btn-danger btn-sm" onClick={e=>del(r,e)}
                              style={r.areCheltuieli?{opacity:0.45,cursor:'help'}:undefined}
                              title={r.areCheltuieli?'Are cheltuieli înregistrate — nu poate fi șters, doar dezactivat':'Șterge'}>🗑️</button>
                          </>
                        )}
                      </td>
                    </tr>
                    {isExpanded && (
                      <tr>
                        <td colSpan={10} style={{padding:0}} onClick={e=>e.stopPropagation()}>
                          {!details ? (
                            <div style={{padding:16}}><Spinner/></div>
                          ) : (
                            <div style={{margin:'8px 12px 16px',padding:16,background:'#f7f9ff',borderRadius:8,border:'1px solid #c0d0e8'}}>
                              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12,flexWrap:'wrap',gap:8}}>
                                <div style={{fontWeight:'bold',color:'#1a3a5c',fontSize:14}}>📊 Detalii — {nr} — {r.marca} — {r.model}</div>
                                <button className="btn btn-sm" style={{background:'#555',color:'white'}}
                                  onClick={()=>printDetaliiVehicul(nr, r.marca, r.model, details)}>🖨️ Print</button>
                              </div>

                              <div style={{marginBottom:6,fontSize:11,fontWeight:'bold',color:'#666',textTransform:'uppercase'}}>Expirări documente</div>
                              <div style={{display:'flex',gap:10,marginBottom:16,flexWrap:'wrap'}}>
                                <ExpCard label="Expirare ITP" value={details.expirareItp} zile={details.itpZile}/>
                                <ExpCard label="Expirare RCA" value={details.expirareRca} zile={details.rcaZile}/>
                                <ExpCard label="Expirare Vigneta" value={details.expirareVigneta} zile={details.vignetaZile}/>
                              </div>

                              <div style={{marginBottom:6,fontSize:11,fontWeight:'bold',color:'#666',textTransform:'uppercase'}}>Statistici</div>
                              <div style={{display:'flex',gap:10,marginBottom:16,flexWrap:'wrap'}}>
                                <StatCard label="Consum mediu" value={details.consumMediu?`${details.consumMediu} l/100km`:null}/>
                                <StatCard label="Ultimii KM înregistrați" value={details.ultimiiKm?`${details.ultimiiKm} km`:null}/>
                                <StatCard label="Ultima revizie" value={details.ultimaRevizie}/>
                              </div>

                              <div style={{marginBottom:6,fontSize:11,fontWeight:'bold',color:'#666',textTransform:'uppercase'}}>Cheltuieli</div>
                              <div className="date-filter-bar" style={{marginBottom:12}}>
                                <label>Perioadă:</label>
                                <input type="date" value={df.dataStart||''} onChange={e=>setDateFilterField(nr,'dataStart',e.target.value)}/>
                                <span className="sep">—</span>
                                <input type="date" value={df.dataEnd||''} onChange={e=>setDateFilterField(nr,'dataEnd',e.target.value)}/>
                                <button className="btn btn-primary btn-sm" onClick={()=>applyDateFilter(nr)}>Aplică</button>
                                {(df.dataStart||df.dataEnd) && <button className="btn btn-sm" style={{background:'#eee'}} onClick={()=>clearDateFilter(nr)}>✕</button>}
                              </div>
                              <div style={{display:'flex',gap:10,flexWrap:'wrap',marginBottom:10}}>
                                <ChelCard label="🔧 Piese" value={details.chelPiese}/>
                                <ChelCard label="🏭 Service" value={details.chelService}/>
                                <ChelCard label="🔵 Vulcanizare" value={details.chelVulcanizare}/>
                                <ChelCard label="🛡️ Asigurări" value={details.chelAsigurari}/>
                                <ChelCard label="📋 Autorizări" value={details.chelAutorizari}/>
                                <ChelCard label="⛽ Carburant" value={details.chelCarburant}/>
                                <ChelCard label="🔩 Revizii" value={details.chelRevizii}/>
                              </div>
                              <div style={{background:'#1a3a5c',color:'white',borderRadius:6,padding:'8px 14px',display:'inline-block',fontWeight:'bold'}}>
                                TOTAL: {parseFloat(details.chelTotal||0).toFixed(2)} RON
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
              {sorted.length === 0 && <tr><td colSpan={10} style={{textAlign:'center',padding:20,color:'#888'}}>Fără date</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <Modal title={modal.mode==='add'?'Adaugă autovehicul':'Editează autovehicul'} onClose={()=>setModal(null)} onSave={save}>
          {modal.mode === 'add' && (
            <div className="form-row single" style={{marginBottom:8}}>
              <button type="button" className="btn btn-sm" style={{background:'#2d6ca2',color:'white'}} onClick={deschideImport}>
                📥 Import (mai multe vehicule deodată)
              </button>
            </div>
          )}
          <div className="form-row">{f('nrInmatriculare','Nr. Înmatriculare')}{f('nrInventar','Nr. Inventar')}</div>
          <div className="form-row">{f('tip','Tip','text',['Autoturism','Autoutilitara','Autocamion','Autobuz','Remorca','Semiremorca','Altele'])}{f('combustibil','Combustibil','text',['Motorina','Benzina','GPL','Electric','Hibrid','KW'])}</div>
          <div className="form-row">{f('marca','Marcă')}{f('model','Model')}</div>
          <div className="form-row">{f('capacitateRezervor','Capacitate rezervor (l)')}{f('serieSasiu','Serie Șasiu')}</div>
          <div className="form-row">{f('dataPrimeiInmatr','Data primei înmatriculări','date')}{f('dataAchizitiei','Data achiziției','date')}</div>
          <div className="form-row">{f('valAchizitie','Valoare achiziție')}{f('kmInitiali','KM inițiali')}{f('nrAxe','Nr. axe')}</div>
          {modal.mode === 'add' && (
            <div className="form-row">
              {f('dataProximaRevizie','Data următoarei revizii','date')}
              {f('kmLimitaRevizie','KM limită pentru revizie')}
            </div>
          )}
          <div className="form-row">{f('anvelopeMarca','Marcă anvelope')}{f('anvelopeTip','Tip anvelope')}</div>
          <div className="form-row">{f('anvelopeMarcaIarna','Marcă anvelope iarnă')}{f('anvelopeTipIarna','Tip anvelope iarnă')}</div>
          <div className="form-row triple">{f('lungime','Lungime')}{f('latime','Lățime')}{f('inaltime','Înălțime')}</div>
          <div className="form-row single">{f('gabarit','Gabarit')}</div>
          <div className="form-row single"><span style={{fontSize:11,color:'#888'}}>* Câmp obligatoriu</span></div>
        </Modal>
      )}

      {importModal && (
        <Modal title="Import vehicule din Excel" onClose={()=>setImportModal(false)}>
          <input ref={fileInputRef} type="file" accept=".xlsx" style={{display:'none'}} onChange={onFisierSelectat}/>

          <div style={{display:'flex',flexDirection:'column',gap:14}}>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <button type="button" className="btn" style={{background:'#217346',color:'white',flex:1}} onClick={descarcaMacheta}>
                📄 Descarcă machetă
              </button>
              <span style={{position:'relative'}}>
                <button type="button" className="btn btn-sm" style={{borderRadius:'50%',width:26,height:26,padding:0}}
                  onClick={()=>setTooltipVizibil(tooltipVizibil==='descarca'?null:'descarca')}>?</button>
                {tooltipVizibil==='descarca' && (
                  <div style={{position:'absolute',right:0,top:32,width:260,background:'#333',color:'white',padding:10,borderRadius:6,fontSize:12,zIndex:10}}>
                    Descarcă un fișier Excel gol, cu toate coloanele necesare pentru a adăuga mai multe vehicule deodată.
                    Primul rând e antetul, al doilea explică ce trebuie completat în fiecare coloană (obligatoriu/opțional,
                    lungime maximă, format). Completează câte un rând pentru fiecare vehicul, apoi încarcă fișierul înapoi
                    cu butonul de mai jos.
                  </div>
                )}
              </span>
            </div>

            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <button type="button" className="btn btn-primary" style={{flex:1}} onClick={incarcaMacheta} disabled={importing}>
                {importing ? 'Se procesează...' : '📤 Încarcă machetă completată'}
              </button>
              <span style={{position:'relative'}}>
                <button type="button" className="btn btn-sm" style={{borderRadius:'50%',width:26,height:26,padding:0}}
                  onClick={()=>setTooltipVizibil(tooltipVizibil==='incarca'?null:'incarca')}>?</button>
                {tooltipVizibil==='incarca' && (
                  <div style={{position:'absolute',right:0,top:32,width:260,background:'#333',color:'white',padding:10,borderRadius:6,fontSize:12,zIndex:10}}>
                    Încarcă fișierul Excel completat. Sistemul verifică fiecare rând — dacă găsește vreo greșeală
                    (câmp obligatoriu gol, text prea lung, dată sau număr greșit, vehicul duplicat), nu adaugă niciun
                    vehicul și îți arată exact ce trebuie corectat. Rândurile complet goale sunt ignorate.
                  </div>
                )}
              </span>
            </div>

            {importSuccessMsg && (
              <div style={{background:'#e8f8ee',color:'#1a7a3a',padding:'10px 14px',borderRadius:6,fontSize:13}}>
                ✅ {importSuccessMsg}
              </div>
            )}

            {importErrorMsg && !importErori && (
              <div style={{background:'#fde8e8',color:'#c0392b',padding:'10px 14px',borderRadius:6,fontSize:13}}>
                ❌ {importErrorMsg}
              </div>
            )}

            {importErori && (
              <div style={{background:'#fde8e8',borderRadius:6,padding:'10px 14px'}}>
                <div style={{color:'#c0392b',fontWeight:'bold',fontSize:13,marginBottom:6}}>{importErrorMsg}</div>
                <ul style={{margin:0,paddingLeft:18,maxHeight:220,overflowY:'auto'}}>
                  {importErori.map((er,i)=>(
                    <li key={i} style={{fontSize:12,color:'#721c24',marginBottom:3}}>{er}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
}
